( function () {
    'use strict';
    /**
     * Checkout
     * @namespace
     */
    master.checkout = {
        /** @function */
        /**
         * Event for emptying cart
         */
        resetCart: function () {
            jQuery( '.js-reset-cart' ).on( 'click', function () {
                master.checkout.cart.commands.emptyCart( 'reload' );
            } );
        },
        /** @function */
        /**
         * Event for removing webshop items from cart
         * @deprecated 
         */
        resetWebshopItems: function () {
            jQuery( '.js-reset-webshopitems' ).on( 'click', function () {
                master.checkout.cart.commands.removeProductlines( 'reload' );
            } );
        },
        /** @function */
        /**
         * Event for removing service items from cart
         */
        resetServiceItems: function () {
            jQuery( '.js-reset-serviceitems' ).on( 'click', function () {
                master.checkout.cart.commands.removeServicelines( master.ecom.addWebshopItemToCart );
            } );
            jQuery( '.js-reset-booking' ).on( 'click', function () {
                master.serviceBooking.edit.delete();
                master.checkout.cart.commands.removeServicelines( 'reload' );
            } );
        },
        /**
         * @namespace
         */
        cart: {
            /**
             * Cart commands
             */
            initiator: jQuery( '.js-master-checkout-step-cart' ).length,
            commands: {
                /** @function */
                /**
                 * Empty cart command
                 * @param {function} callback
                 * @async
                 */
                emptyCart: function ( callback ) {
                    jQuery.post( location.href, {
                        cartcmd: 'emptycart',
                    }, function ( data ) {
                        if ( callback ) {
                            if ( callback === 'reload' ) {
                                location.reload();
                            }
                            else {
                                callback( data );
                            }
                        }
                    } );
                },
                /** @function */
                /**
                 * Add to cart command
                 * @param {string} productid
                 * @param {function} callback
                 * @param {string} param
                 * @async
                 */
                addToCart: function ( productid, callback, param ) {
                    jQuery.post( location.href, {
                        cartcmd: 'add',
                        productid: productid
                    }, function ( data ) {
                        if ( callback ) {
                            if ( callback === 'reload' && !param ) {
                                location.reload();
                            }
                            else if ( callback === 'reload' && param ) {
                                location.href = location.href + param;
                            }
                            else {
                                callback( data );
                            }
                        }
                    } );
                },
                /** @function */
                /**
                 * Remove service orderline from cart
                 * @param {function} callback
                 * @async
                 */
                removeServicelines: function ( callback ) {
                    jQuery.ajax( {
                        url: master.data.orderHandler.endpoint,
                        type: 'POST',
                        data: {
                            action: master.data.orderHandler.actions.removeservicelines
                        },
                        async: false
                    } ).done( function ( data ) {
                        var jData = data;
                        jQuery.ajax( {
                            url: master.data.serviceCalendar.endpoint,
                            type: 'POST',
                            data: {
                                action: master.data.serviceCalendar.actions.delete
                            },
                            async: false
                        } ).done( function ( data, textStatus, xhr ) {
                            if ( xhr.status > 199 && xhr.status < 300 ) {
                                if ( callback ) {
                                    if ( callback === 'reload' ) {
                                        location.reload();
                                    }
                                    else {
                                        callback( jData );
                                    }
                                }
                            }
                        } );
                    } );
                },
                /** @function */
                /**
                 * Remove product orderline from cart
                 * @param {function} callback
                 * @deprecated
                 * @async
                 */
                removeProductlines: function ( callback ) {
                    jQuery.post( master.data.orderHandler.endpoint, {
                        action: master.data.orderHandler.actions.removeproductlines
                    }, function ( data ) {
                        if ( callback === 'reload' ) {
                            location.reload();
                        }
                        else {
                            callback( data );
                        }
                    } );
                }
            },
            /** @function */
            /**
             * Cart validation
             */
            validation: function () {
                jQuery( 'form[name="CheckoutCartForm"]' ).validate( {
                    errorLabelContainer: '.js-checkout-validation-errors',
                    wrapper: 'ul',
                    errorElement: 'li',
                    submitHandler: function ( form ) {
                        form.submit();
                    }
                } );
            },
            /**
             * @namespace
             */
            booking: {
                /** @function */
                /**
                 * Check if service date is present and add event to clear reserved time
                 * @async
                 */
                reserved: function () {
                    var isReserved = jQuery( '.js-service-date' ).val() !== '' ? true : false;
                    if ( isReserved ) {
                        jQuery( '.js-servicebooking-reserved' ).show().on( 'click', '.js-servicebooking-reserved-unlock', function () {
                            jQuery.post( master.data.serviceCalendar.endpoint, {
                                action: master.data.serviceCalendar.actions.delete
                            }, function ( data, textStatus, xhr ) {
                                if ( xhr.status > 199 && xhr.status < 300 ) {
                                    location.reload();
                                }
                            } );
                        } );
                    }
                },
                init: function () {
                    this.reserved();
                }
            },
            /**
             * @namespace
             * @deprecated
             * @property {string} banneswiper.options
             */
            swipe: {
                options: {
                    actionWidth: 100,
                    swipeThreshold: 50,
                    hintDelay: 3000,
                    hintShowMax: 3
                },
                hintTimeout: undefined,
                /** @function */
                /**
                 * Get touchSwipe vendor script
                 * @async
                 */
                getScript: function () {
                    var that = this;
                    jQuery.getScript( '//cdnjs.cloudflare.com/ajax/libs/jquery.touchswipe/1.6.18/jquery.touchSwipe.js', function () {
                        that.gesture();
                        that.confirmations();
                    } );
                },
                /** @function */
                /**
                 * Hint the user to the functionality
                 */
                hint: function () {
                    var firstSwipeItem = jQuery( '.js-swipe-container' ).first().find( '.js-swipe-list' );
                    firstSwipeItem.addClass( 'swipe-list-hint' );
                    firstSwipeItem.one( master.settings.animationEnd, function () {
                        firstSwipeItem.removeClass( 'swipe-list-hint' );
                    } );
                },
                /** @function */
                /**
                 * Swipe gestures
                 */
                gesture: function () {
                    var that = this,
                        intervalCount = 0;
                    if ( sessionStorage.swipehint !== 'true' ) {
                        that.hintTimeout = setInterval( function () {
                            that.hint();
                            intervalCount++;
                            if ( intervalCount === that.options.hintShowMax ) {
                                clearInterval( that.hintTimeout );
                                return false;
                            }
                        }, that.options.hintDelay );
                    }
                    jQuery( '.js-swipe-container' ).swipe( {
                        threshold: that.options.swipeThreshold,
                        swipeStatus: function ( event, phase, direction, distance ) {
                            var swipeDistance = ( distance - that.options.actionWidth ) <= 0 ? ( distance - that.options.actionWidth ) : 0,
                                swipeAnimatedDistance = direction === 'left' ? ( -swipeDistance - that.options.actionWidth ) : ( swipeDistance + that.options.actionWidth ),
                                swipeOppositeDirection = direction === 'left' ? 'right' : 'left',
                                swipeMaxDistance = direction === 'left' ? -that.options.actionWidth : that.options.actionWidth,
                                jThis = jQuery( this ),
                                jItem = jThis.find( '.js-swipe-list' );
                            if ( phase === 'move' ) {
                                if ( that.hintTimeout ) {
                                    clearInterval( that.hintTimeout );
                                }
                                if ( jItem.is( '.' + swipeOppositeDirection ) ) {
                                    jItem.css( 'left', 0 ).removeClass( swipeOppositeDirection );
                                    return false;
                                }
                                else {
                                    jItem.css( 'left', swipeAnimatedDistance ).addClass( direction );
                                }
                            }
                            else if ( phase === 'cancel' ) {
                                if ( direction !== null ) {
                                    jItem.css( 'left', 0 ).removeClass( 'left right' );
                                }
                            }
                            else if ( phase === 'end' ) {
                                if ( direction !== null ) {
                                    jItem.css( 'left', swipeMaxDistance ).addClass( direction );
                                    sessionStorage.swipehint = true;
                                }
                            }
                        }
                    } );
                },
                /** @function */
                /**
                 * Confirm swipe
                 */
                confirmations: function () {
                    jQuery( '.js-swipe-list-item-action-confirmation-trigger' ).on( 'click', function () {
                        jQuery( this ).parent().find( '.js-swipe-list-item-action-confirmation' ).addClass( 'open' );
                    } );
                    jQuery( '.js-swipe-list-item-action-cancel' ).on( 'click', function () {
                        jQuery( this ).parent( '.js-swipe-list-item-action-confirmation' ).removeClass( 'open' );
                        jQuery( '.js-swipe-list' ).css( 'left', 0 );
                    } );
                },
                init: function () {
                    this.getScript();
                }
            },
            init: function () {
                if ( this.initiator ) {
                    this.validation();
                    this.booking.init();
                    if ( jQuery( '.js-swipe-container' ).length && master.utils.isMobile( navigator.userAgent || navigator.vendor || window.opera ) && espresso.constant.jWindow.width() < 768 ) {
                        this.swipe.init();
                    }
                }
            }
        },
        /**
         * @namespace
         */
        delivery: {
            initiator: jQuery( '.js-master-checkout' ).length,
            /** @function */
            /**
             * Validate delivery step
             */
            validation: function () {
                jQuery( 'input[name="Co3EspressoCustomerType"]:checked' ).trigger( 'change' );
                jQuery( 'form[name="CheckoutDeliveryForm"]' ).validate( {
                    rules: {
                        EcomUserCreateUserName: {
                            equalTo: '#EcomOrderCustomerEmail'
                        },
                        EcomUserCreatePassword: {
                            equalTo: '#EcomUserCreateConfirmPassword'
                        },
                        EspressoGLSshopSearchString: {
                            'digits': true,
                            minlength: 4,
                            maxlength: 4
                        },
                        Co3EspressoCustomerPassword: 'required',
                        Co3EspressoCustomerConfirmPassword: {
                            equalTo: '#Co3EspressoCustomerPassword_1'
                        }
                    },
                    groups: {
                        EcomOrderCustomerZipCity: 'EcomOrderCustomerZip EcomOrderCustomerCity',
                        EcomOrderDeliveryZipCity: 'EcomOrderDeliveryZip EcomOrderDeliveryCity'
                    },
                    messages: {
                        Co3EspressoCustomerConfirmPassword: 'Kodeordet er ikke ens'
                    },
                    errorLabelContainer: '.js-checkout-validation-errors',
                    wrapper: 'ul',
                    errorElement: 'li',
                    invalidHandler: function () {
                        jQuery( '.js-checkout-validation-errors' ).html( '' );
                        co3.util.scroll.toElement( jQuery( 'body' ), 0, true, true );
                    },
                    submitHandler: function ( form ) {
                        if ( jQuery( '#Co3EspressoCustomerType_New' ).is( ':checked' ) ) {
                            master.checkout.delivery.checkEmail( form, jQuery( '#EcomOrderCustomerEmail' ).val() );
                        }
                        else {
                            form.submit();
                        }
                    }
                } );
            },
            /** @function */
            /**
             * Validate email to check if user exists
             * @param {HTMLFormElement} form
             * @param {string} username
             */
            checkEmail: function ( form, username ) {
                jQuery.ajax( {
                    url: master.data.orderHandler.endpoint,
                    type: 'post',
                    async: false,
                    data: {
                        action: master.data.orderHandler.actions.checkusername,
                        username: username
                    }
                } ).done( function ( data ) {
                    if ( data.Data === true ) {
                        co3.util.scroll.toElement( jQuery( 'body' ), 0, true, true );
                        jQuery( '.js-checkout-validation-errors' ).html( '<ul><li>Der findes allerede en bruger med den angivne email</li></ul>' ).show();
                        return false;
                    }
                    else {
                        jQuery( '.js-checkout-validation-errors' ).html( '' );
                        form.submit();
                    }
                } );
            },
            /** @function */
            /**
             * Update car info from session store
             */
            updateCarInfo: function () {
                var myBookingInfo = sessionStorage.preservedBookingForm;
                if ( myBookingInfo !== undefined ) {
                    myBookingInfo = JSON.parse( myBookingInfo );
                    if ( myBookingInfo.carinfo_reg_date.value !== '' ) {
                        jQuery( '[data-booking-carinfo="regdate"]' ).show().find( '.js-checkout-booking-carinfo' ).html( myBookingInfo.carinfo_reg_date.value );
                    }
                    if ( myBookingInfo.EcomOrderLineFieldInput_Milage.value !== '' ) {
                        jQuery( '[data-booking-carinfo="milage"]' ).show().find( '.js-checkout-booking-carinfo' ).html( myBookingInfo.EcomOrderLineFieldInput_Milage.value );
                    }
                    if ( myBookingInfo.EcomOrderLineFieldInput_transmissions !== undefined ) {
                        jQuery( '[data-booking-carinfo="transmission"]' ).show().find( '.js-checkout-booking-carinfo' ).html( myBookingInfo.EcomOrderLineFieldInput_transmissions.text );
                    }
                    if ( myBookingInfo.EcomOrderLineFieldInput_systems !== undefined ) {
                        jQuery( '[data-booking-carinfo="system"]' ).show().find( '.js-checkout-booking-carinfo' ).html( myBookingInfo.EcomOrderLineFieldInput_systems.text );
                    }
                }
            },
            /** @function */
            /**
             * Create user in checkout
             */
            createUser: function () {
                jQuery( '#CustomerType' ).find( '.js-customertype-selection-new' ).on( 'click', function () {
                    var jThis = jQuery( this );
                    jQuery( '#CustomerType' ).find( '.js-customertype-selection-guest' ).removeClass( 'active selected' );
                    jQuery( 'input[name="EcomUserCreateUserName"]' ).val( jQuery( 'input[name="EcomOrderCustomerEmail"]' ).val() );
                    if ( jQuery( this ).is( '.selected' ) ) {
                        jQuery( '.user-create-password' ).slideUp( master.settings.animateSpeed, function () {
                            jThis.removeClass( 'active selected' );
                            jQuery( '#CustomerType' ).find( '.js-customertype-selection-guest' ).addClass( 'active selected' );
                        } );
                        jQuery( '#Co3EspressoCustomerType_New' ).prop( 'checked', false );
                        jQuery( 'input[name="EcomUserCreateUserName"]' ).val( '' );
                    }
                    else {
                        jQuery( '.user-create-password' ).slideDown( master.settings.animateSpeed, function () {
                            jThis.addClass( 'active selected' );
                        } );
                        jQuery( 'input[name="EcomUserCreateNew"]' ).prop( 'checked', true );
                    }
                } );
                jQuery( 'input[name="EcomOrderCustomerEmail"]' ).on( 'change', function () {
                    jQuery( 'input[name="EcomUserCreateUserName"]' ).val( jQuery( this ).val() );
                } );
            },
            /** @function */
            /**
             * Login from checkout
             */
            login: function () {
                jQuery( '#CustomerType' ).find( '.js-customertype-selection-extranet' ).on( 'click', function () {
                    jQuery( 'input[name="Username"]' ).val( jQuery( 'input[name="EcomOrderCustomerEmail"]' ).val() );
                    jQuery( '.js-e-login-modal' ).modal();
                } );
                jQuery( 'input[name="EcomOrderCustomerEmail"]' ).on( 'change', function () {
                    jQuery( 'input[name="Username"]' ).val( jQuery( this ).val() );
                } );
            },
            /** @function */
            /**
             * Guest user
             */
            guest: function () {
                jQuery( '#CustomerType' ).find( '.js-customertype-selection-guest' ).on( 'click', function () {
                    jQuery( '#CustomerType' ).find( '.js-customertype-selection-guest' ).addClass( 'active selected' );
                    jQuery( 'input[name="Co3EspressoCustomerType"][value="new"]' ).prop( 'checked', false );
                    jQuery( '.user-create-password' ).slideUp( master.settings.animateSpeed );
                    jQuery( '#CustomerType' ).find( '.js-customertype-selection-new' ).removeClass( 'active selected' );
                    jQuery( '#CustomerType' ).find( '.js-customertype-selection-extranat' ).removeClass( 'active selected' );
                    jQuery( 'input[name="Co3EspressoCustomerType"][value="extranet"]' ).prop( 'checked', false );
                } );
            },
            /** @function */
            /**
             * Custom input logic
             */
            formDeliveryAlt: function () {
                if ( jQuery( 'form.delivery-alt' ).length > 0 ) {
                    jQuery( 'input[type="checkbox"], input[type="radio"]' ).not( '.custom-input' ).each( function () {
                        if ( jQuery( this ).is( ':checked' ) ) {
                            jQuery( this ).parent().addClass( 'selected' );
                        }
                    } ).on( 'change', function () {
                        if ( jQuery( this ).is( ':checked' ) ) {
                            jQuery( this ).parent().addClass( 'selected' );
                        }
                        else {
                            jQuery( this ).parent().removeClass( 'selected' );
                        }
                    } );
                }
            },
            init: function () {
                if ( this.initiator ) {
                    this.createUser();
                    this.login();
                    this.guest();
                    this.validation();
                    this.formDeliveryAlt();
                    this.updateCarInfo();
                }
            }
        },
        /**
         * @namespace
         */
        approve: {
            /** @function */
            /**
             * Validate approve step
             */
            validation: function () {
                jQuery('.js-booking-start-over').on('click', function() {
                    location.href = '/book-tid';
                });
                jQuery( 'form[name="CheckoutApproveForm"]' ).validate( {
                    errorLabelContainer: '.js-checkout-validation-errors',
                    wrapper: 'ul',
                    errorElement: 'li',
                    invalidHandler: function () {
                        co3.util.scroll.toElement( jQuery( 'body' ), 0, true, true );
                    },
                    submitHandler: function ( form ) {
                        var urlBuilder = new URL(location.origin + master.data.serviceCalendar.endpoint);
                        urlBuilder.searchParams.append('action', 'checkForTempApp');
                        urlBuilder.searchParams.append('tempAppointmentId', checkoutInfo.plannerID);

                        jQuery.ajax( {
                            url: urlBuilder.href,
                            type: 'GET',
                            async: false
                        } ).done( function ( data, textStatus, xhr ) {
                            if ( data.Data != false ) {
                                jQuery( window ).off( 'beforeunload' );
                                master.serviceBooking.edit.delete();
                                form.submit();
                            } else {
                                jQuery('#CheckoutTimedOutModal').modal('show');
                            }
                        } );
                    }
                } );
            },
            /** @function */
            /**
             * check if we should pop a dialogue, to let the user know they haven't completed the checkout process
             */
            unsavedData: function () {
                if ( jQuery( '.js-master-webshop-checkout-step-approve' ).length === 1 ) {
                    var errorMessage = jQuery( '.js-checkout-approve-unsaved-msg' ).text();
                    jQuery( window ).on( 'beforeunload', function () {
                        return errorMessage;
                    } );
                    jQuery( 'body' ).on( 'click', 'a:not([href="javascript:void(0);"], [data-toggle], [data-dismiss] )', function ( event ) {
                        event.preventDefault();
                        master.checkout.approve.unsavedDataModal( this.href, errorMessage );
                    } );
                }
            },
            /** @function */
            /**
             * Show dialog before unload of page
             * @param {string} href
             * @param {string} errorMessage
             */
            unsavedDataModal: function ( href, errorMessage ) {
                jQuery( '.js-checkout-unsaved-modal' ).find( '.modal-body' ).html( errorMessage );
                jQuery( '.js-checkout-unsaved-modal' ).modal();
                jQuery( '.js-checkout-unsaved-modal-leave' ).on( 'click', function () {
                    jQuery( window ).off( 'beforeunload' );
                    window.location.href = href;
                } );
            },
            handleTermsAndCondCheckboxes: function(){
                var jCheckboxes = jQuery( '.js-ftz-EcomOrderCustomerAccepted' );
                jCheckboxes.on( 'change', function ( event ) {
                    jCheckboxes.not( event.target ).prop( 'checked', jQuery( event.target ).prop( 'checked' ) === true );
                    $(".js-checkout-validation-errors").css("display", "none");
                } );
            },
            testForPlannerID: function(){
              var plannerID = window.hasBookingPlannerID;
              jQuery('.js-checkout-lost-PlannerID-modal-leave').on('click', function(event){
                  event.preventDefault();
                  jQuery( window ).off( 'beforeunload' );
                  location.href = jQuery(this).attr('href'); 
							});

              if(plannerID === ''){
                  jQuery.post( master.data.serviceCalendar.endpoint, {
                      action: master.data.serviceCalendar.actions.delete
                  }, function ( data, textStatus, xhr ) {
                      if ( xhr.status > 199 && xhr.status < 300 ) {
                          jQuery('.js-submit-service-order').remove();
                          jQuery('.js-checkout-lost-plannerID-modal').modal('show');
                      }
                  } );
              }
            },
            init: function () {
                master.checkout.approve.unsavedData();
                master.checkout.approve.testForPlannerID();
                master.checkout.approve.validation();
                master.checkout.approve.handleTermsAndCondCheckboxes();
            }
        },
        errModal: function(){
          if(jQuery('.js-master-err-modal').length){
              jQuery('.js-master-err-modal').modal();
          }
        },
        init: function () {
            this.errModal();
            this.resetCart();
            this.resetWebshopItems();
            this.resetServiceItems();
            this.cart.init();
            this.delivery.init();
            this.approve.init();
            master.utils.autoSessionExtender(600000);
        }
    };
}() );
